<div class="whatsapp-chat-dialog" appFitAboveKeyboard>
    <div class="dialog-header">
        <div class="header-content">
            <mat-icon svgIcon="whatsapp"></mat-icon>
            <h3>WhatsApp Messages</h3>
            <span *ngIf="patient" class="patient-name">{{ patient.name }} {{ patient.surname }}</span>
        </div>
        <button mat-icon-button (click)="close()" matTooltip="Close" class="m-r-5">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Credit balance warnings -->
    <div class="token-balance-warning" *ngIf="textMessageBalance !== null && hasLowCredits && !hasInsufficientCredits">
        <mat-icon>warning</mat-icon>
        <p class="p-l-10">You have <strong>{{ textMessageBalance }}</strong> text message credits left.
            Please recharge soon to ensure you are able to continue sending WhatsApp messages.</p>
    </div>
    <div class="token-balance-warning" *ngIf="textMessageBalance !== null && hasInsufficientCredits">
        <mat-icon>error</mat-icon>
        <p class="p-l-10">You currently have <strong>{{ textMessageBalance }}</strong> text message
            credits remaining (requires {{ WHATSAPP_MESSAGE_COST }} credits per message). To continue sending WhatsApp
            messages, please recharge your credits.</p>
    </div>

    <div class="dialog-content" *ngIf="patient">
        <div class="conversations-sidebar" [class.collapsed]="!sidebarExpanded">
            <div class="sidebar-header">
                <h4>Conversations</h4>
                <div class="sidebar-header-actions">
                    <button mat-icon-button *ngIf="isMobile" (click)="toggleSidebar()" class="sidebar-close-mobile"
                        matTooltip="Close conversations">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            <div class="broadcast-hint" *ngIf="!broadcastMode">
                <mat-icon>info</mat-icon>
                <span>Press and hold on a conversation to enable broadcast sending</span>
            </div>
            <div class="broadcast-mode-indicator" *ngIf="broadcastMode">
                <mat-icon>send</mat-icon>
                <span>Broadcast mode: {{ selectedConversationsForBroadcast.size }} selected</span>
                <button mat-icon-button (click)="exitBroadcastMode()" class="exit-broadcast-btn-sidebar"
                    matTooltip="Exit broadcast mode">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="conversations-list" *ngIf="conversations.length > 0">
                <div *ngFor="let conversation of conversations" class="conversation-item"
                    [class.active]="selectedConversation?.phoneNumber === conversation.phoneNumber"
                    [class.empty-conversation]="conversation.isEmpty"
                    [class.broadcast-selected]="broadcastMode && selectedConversationsForBroadcast.has(conversation.phoneNumber)"
                    (click)="onConversationClick(conversation, $event)"
                    (mousedown)="onConversationMouseDown(conversation, $event)"
                    (mouseup)="onConversationMouseUp($event)" (mouseleave)="onConversationMouseLeave($event)"
                    (touchstart)="onConversationTouchStart(conversation, $event)"
                    (touchend)="onConversationTouchEnd($event)" (touchcancel)="onConversationTouchCancel($event)">
                    <mat-checkbox *ngIf="broadcastMode"
                        [checked]="selectedConversationsForBroadcast.has(conversation.phoneNumber)"
                        (click)="$event.stopPropagation()"
                        (change)="toggleConversationForBroadcast(conversation, $event.checked)"
                        class="broadcast-checkbox">
                    </mat-checkbox>
                    <div class="conversation-content">
                        <div class="conversation-header">
                            <mat-icon class="phone-icon">phone</mat-icon>
                            <div class="conversation-info">
                                <div class="conversation-title">
                                    <span class="person-name" *ngIf="conversation.personName">
                                        {{ conversation.personName }}
                                    </span>
                                    <span class="phone-number" *ngIf="!conversation.personName">{{
                                        formatPhoneNumber(conversation.phoneNumber) }}</span>
                                    <span *ngFor="let label of conversation.relationshipLabels"
                                        class="number-badge relationship" [class.patient]="label === 'Patient'"
                                        [class.account-responsible]="label === 'Account Responsible'"
                                        [class.emergency-contact]="label.startsWith('Emergency Contact')"
                                        [class.work]="label === 'Work'" [matTooltip]="label">
                                        {{ label }}
                                    </span>
                                </div>
                                <div class="phone-number-secondary" *ngIf="conversation.personName">
                                    {{ formatPhoneNumber(conversation.phoneNumber) }}
                                </div>
                            </div>
                        </div>
                        <div class="conversation-preview" *ngIf="conversation.lastMessage && !broadcastMode">
                            <span class="last-message" [class.pending]="conversation.hasPendingMessage">
                                <mat-icon *ngIf="conversation.hasPendingMessage"
                                    class="pending-icon">schedule</mat-icon>
                                {{ conversation.lastMessage.content || (conversation.lastMessage.mediaUrl ? '[Media]' :
                                '[Message]') }}
                            </span>
                            <span class="last-message-time">
                                {{ formatMessageTime(conversation.lastMessage) }}
                            </span>
                        </div>
                        <div class="conversation-preview empty" *ngIf="conversation.isEmpty && !broadcastMode">
                            <span class="empty-message">New conversation - no messages yet</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-conversations-message" *ngIf="conversations.length === 0">
                <mat-icon>chat_bubble_outline</mat-icon>
                <p>No conversations yet</p>
                <p class="hint" *ngIf="!patient.mobileNumber">
                    Patient has no mobile number. Search for colleagues below to start a conversation.
                </p>
                <p class="hint" *ngIf="patient.mobileNumber">
                    Start a conversation by sending a message or search for colleagues below.
                </p>
            </div>
            <div class="colleague-search-section">
                <div class="input-container">
                    <mat-icon class="search-icon">search</mat-icon>
                    <mat-form-field appearance="outline" class="colleague-search-input">
                        <input matInput [formControl]="colleagueSearchControl" [placeholder]="'Search colleagues'"
                            [matAutocomplete]="colleagueAuto" (keydown)="handleColleagueSearchKeydown($event)">
                        <mat-autocomplete #colleagueAuto="matAutocomplete" [displayWith]="displayColleagueFn"
                            (optionSelected)="onColleagueSelected($event.option.value)">
                            <mat-option *ngFor="let colleague of filteredColleagues$ | async" [value]="colleague">
                                <div class="colleague-option">
                                    <div class="colleague-name">
                                        {{ colleague.title }} {{ colleague.name }} {{ colleague.surname }}
                                        <span class="colleague-speciality" *ngIf="colleague.speciality">
                                            ({{ colleague.speciality }})
                                        </span>
                                    </div>
                                    <div class="colleague-phone">
                                        {{ formatPhoneNumber(colleague.contactNumber) }}
                                    </div>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="chat-area" [class.full-width]="conversations.length === 0 || !sidebarExpanded">
            <!-- Always show a header with sidebar toggle, even when no conversation is selected -->
            <div class="chat-header" *ngIf="!selectedConversation && !broadcastMode">
                <div class="chat-header-info">
                    <button mat-icon-button (click)="toggleSidebar()" class="sidebar-toggle"
                        [matTooltip]="sidebarExpanded ? 'Hide conversations' : 'Show conversations'">
                        <mat-icon>{{ sidebarExpanded ? 'chevron_left' : 'menu' }}</mat-icon>
                    </button>
                    <mat-icon class="phone-icon">chat</mat-icon>
                    <div class="chat-header-details">
                        <span class="chat-phone-number">Select a conversation</span>
                        <span class="chat-phone-number-secondary" *ngIf="!patient.mobileNumber">
                            Patient has no mobile number
                        </span>
                    </div>
                </div>
            </div>
            <div class="chat-header" *ngIf="selectedConversation && !broadcastMode">
                <div class="chat-header-info">
                    <button mat-icon-button (click)="toggleSidebar()" class="sidebar-toggle"
                        [matTooltip]="sidebarExpanded ? 'Hide conversations' : 'Show conversations'">
                        <mat-icon>{{ sidebarExpanded ? 'chevron_left' : 'menu' }}</mat-icon>
                    </button>
                    <mat-icon class="phone-icon">phone</mat-icon>
                    <div class="chat-header-details">
                        <span class="chat-person-name" *ngIf="selectedConversation.personName">
                            {{ selectedConversation.personName }}
                        </span>
                        <span class="chat-phone-number" *ngIf="!selectedConversation.personName">
                            {{ formatPhoneNumber(selectedConversation.phoneNumber) }}
                        </span>
                        <span class="chat-phone-number-secondary" *ngIf="selectedConversation.personName">
                            {{ formatPhoneNumber(selectedConversation.phoneNumber) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="broadcast-mode-chat-header" *ngIf="broadcastMode">
                <div class="chat-header-info">
                    <button mat-icon-button (click)="toggleSidebar()" class="sidebar-toggle"
                        [matTooltip]="sidebarExpanded ? 'Hide conversations' : 'Show conversations'">
                        <mat-icon>{{ sidebarExpanded ? 'chevron_left' : 'menu' }}</mat-icon>
                    </button>
                    <mat-icon class="phone-icon">send</mat-icon>
                    <div class="chat-header-details">
                        <span class="chat-phone-number">Broadcast Mode</span>
                        <span class="chat-person-name">
                            {{ selectedConversationsForBroadcast.size }} conversation{{
                            selectedConversationsForBroadcast.size !== 1 ? 's' : '' }} selected
                        </span>
                    </div>
                </div>
            </div>

            <div class="communication-notice" *ngIf="selectedConversation && !broadcastMode">
                <mat-icon>info</mat-icon>
                <span>This is intended for one-way communication from your practice. Replies will not be tracked.</span>
            </div>

            <div class="chat-messages" #messagesContainer *ngIf="selectedConversation || broadcastMode"
                (scroll)="onScroll($event)">
                <div *ngIf="broadcastMode && messages.length === 0" class="no-messages">
                    <mat-icon>send</mat-icon>
                    <p>Broadcast mode active</p>
                    <p class="hint" *ngIf="selectedConversationsForBroadcast.size === 0">
                        Open the conversations menu to select recipients, then type a message to send to all selected
                        recipients
                    </p>
                    <p class="hint" *ngIf="selectedConversationsForBroadcast.size > 0">
                        {{ selectedConversationsForBroadcast.size }} conversation{{
                        selectedConversationsForBroadcast.size !== 1 ? 's' : '' }} selected. Type a message to send to
                        all selected recipients. Open the conversations menu to manage selections.
                    </p>
                </div>
                <div *ngIf="loadingMore" class="loading-messages-top">
                    <mat-spinner diameter="24"></mat-spinner>
                    <span>Loading previous messages...</span>
                </div>

                <div *ngIf="loading && !broadcastMode" class="loading-messages">
                    <mat-spinner diameter="24"></mat-spinner>
                    <span>Loading messages...</span>
                </div>

                <!-- Shared payload renderer used by both standard and pending
                     bubbles so media (image / video / audio / document) and
                     captions render identically regardless of delivery state.
                     Pending bubbles wrap this with a state banner and action
                     buttons; standard bubbles wrap it with status-icon and
                     button-response / template-info indicators. -->
                <ng-template #messagePayload let-message>
                    <!-- Text message without media -->
                    <div *ngIf="message.content && !message.mediaUrl"
                        [innerHTML]="message.content | formatMessage"></div>

                    <!-- Media message -->
                    <div *ngIf="message.mediaUrl" class="media-message">
                        <!-- Image -->
                        <img *ngIf="message.mediaType?.startsWith('image/')" [src]="message.mediaUrl"
                            [alt]="message.mediaFileName || 'Image'" (error)="onImageError($event)"
                            (click)="openImageViewer(message)" class="clickable-image">

                        <!-- Video -->
                        <video *ngIf="message.mediaType?.startsWith('video/')" [src]="message.mediaUrl"
                            controls [title]="message.mediaFileName || 'Video'"></video>

                        <!-- Audio/Voice Note -->
                        <div *ngIf="message.mediaType?.startsWith('audio/')" class="voice-note-player"
                            [class.playing]="message._audioPlaying">
                            <button class="play-pause-btn" type="button" (click)="toggleAudioPlayback(message)"
                                [attr.aria-label]="message._audioPlaying ? 'Pause' : 'Play'">
                                <mat-icon>{{ message._audioPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
                            </button>
                            <div class="voice-note-content">
                                <div class="voice-note-progress">
                                    <div class="progress-bar">
                                        <div class="progress-fill"
                                            [style.width.%]="message._audioProgress || 0"></div>
                                    </div>
                                </div>
                                <div class="voice-note-info">
                                    <span class="voice-note-duration">{{ message._audioDurationFormatted ||
                                        '0:00 / 0:00' }}</span>
                                    <mat-icon class="waveform-icon">graphic_eq</mat-icon>
                                </div>
                            </div>
                            <audio
                                [id]="'audio-' + (message._messageKey || message.id || message.messageId)"
                                [src]="message.mediaUrl"
                                (loadedmetadata)="onAudioMetadataLoaded(message, $event)"
                                (timeupdate)="onAudioTimeUpdate(message, $event)"
                                (ended)="onAudioEnded(message)" (error)="onAudioError(message, $event)"
                                [style.display]="'none'" preload="metadata">
                            </audio>
                        </div>

                        <!-- Document or other media -->
                        <div *ngIf="!message.mediaType?.startsWith('image/') && !message.mediaType?.startsWith('video/') && !message.mediaType?.startsWith('audio/')"
                            class="document-preview">
                            <mat-icon>{{ message.mediaType?.startsWith('application/pdf') ? 'picture_as_pdf'
                                : 'insert_drive_file' }}</mat-icon>
                            <span>{{ message.mediaFileName || '[Media]' }}</span>
                        </div>

                        <!-- Caption (if present and not placeholder) -->
                        <div *ngIf="message._hasValidCaption" class="media-caption"
                            [innerHTML]="message.content | formatMessage"></div>

                        <!-- View/download link -->
                        <a [href]="message.mediaUrl" target="_blank" matTooltip="View/download media"
                            *ngIf="!message.mediaType?.startsWith('image/') || message.content">
                            <mat-icon>open_in_new</mat-icon>
                        </a>
                    </div>
                </ng-template>

                <ng-container *ngIf="!broadcastMode">
                    <div *ngFor="let message of messages; let i = index" class="message-wrapper">
                        <div *ngIf="shouldShowDateSeparator(message, messages[i-1])" class="date-separator">
                            {{ formatMessageDate(message) }}
                        </div>

                        <!-- Pending message bubble (queued behind consent template) -->
                        <div *ngIf="isPending(message)"
                            class="message-bubble outbound pending-row"
                            [class.pending-state-pending]="message.status === 'pending'"
                            [class.pending-state-processing]="message.status === 'processing'"
                            [class.pending-state-expired]="message.status === 'expired'"
                            [class.pending-state-rejected]="message.status === 'rejected'">
                            <div class="message-content">
                                <div class="pending-banner">
                                    <mat-icon>{{ pendingStatusIcon(message) }}</mat-icon>
                                    <span>{{ pendingStatusLabel(message) }}</span>
                                </div>

                                <ng-container
                                    *ngTemplateOutlet="messagePayload; context: { $implicit: message }">
                                </ng-container>

                                <!-- Fallback for the brief moment between optimistic-add and the
                                     first socket event when mediaUrl hasn't populated yet. -->
                                <div *ngIf="!message.mediaUrl && !message.content && message.messageType === 'voice'"
                                    class="pending-payload-fallback">
                                    <mat-icon>mic</mat-icon>
                                    <span>Voice note</span>
                                </div>
                                <div *ngIf="!message.mediaUrl && !message.content && message.messageType === 'media'"
                                    class="pending-payload-fallback">
                                    <mat-icon>attach_file</mat-icon>
                                    <span>{{ message.mediaFileName || 'Attached file' }}</span>
                                </div>

                                <div *ngIf="message.status !== 'processing'" class="pending-actions">
                                    <button *ngIf="message.retryable !== false" type="button"
                                        class="pending-action-btn pending-retry-btn"
                                        (click)="retryPendingMessage(message)">
                                        <mat-icon>refresh</mat-icon>
                                        <span>Retry</span>
                                    </button>
                                    <button type="button"
                                        class="pending-action-btn pending-cancel-btn"
                                        (click)="cancelPendingMessage(message)">
                                        <mat-icon>delete_outline</mat-icon>
                                        <span>Cancel</span>
                                    </button>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="message-time">{{ formatMessageTime(message) }}</span>
                            </div>
                        </div>

                        <!-- Standard delivered/inbound message bubble -->
                        <div *ngIf="!isPending(message)" class="message-bubble"
                            [class.inbound]="message.direction === 'inbound'"
                            [class.outbound]="message.direction === 'outbound'"
                            [class.failed]="message.status === 'failed'"
                            [class.rejected]="message.status === 'rejected'"
                            [class.pending]="message.status === 'pending_button_response'">
                            <div class="message-content">
                                <!-- Pending button response indicator -->
                                <div *ngIf="message.status === 'pending_button_response'" class="pending-indicator">
                                    <mat-icon>schedule</mat-icon>
                                    <span>Waiting for user to confirm...</span>
                                </div>

                                <!-- Rejected message indicator -->
                                <div *ngIf="message.status === 'rejected'" class="rejected-indicator">
                                    <mat-icon>cancel</mat-icon>
                                    <span>Message was rejected by user</span>
                                </div>

                                <ng-container
                                    *ngTemplateOutlet="messagePayload; context: { $implicit: message }">
                                </ng-container>

                                <!-- Button response indicator -->
                                <div *ngIf="message.messageType === 'button' && message.content"
                                    class="button-response">
                                    <mat-icon>touch_app</mat-icon>
                                    <span>User selected: {{ message.content }}</span>
                                </div>

                                <!-- Template info -->
                                <div *ngIf="message.templateName" class="template-info">
                                    <mat-icon>handshake</mat-icon>
                                    <span>Practice introduction message sent</span>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="message-time">{{ formatMessageTime(message) }}</span>
                                <mat-icon *ngIf="message.status === 'sent'" class="status-icon sent">done</mat-icon>
                                <mat-icon *ngIf="message.status === 'delivered'"
                                    class="status-icon delivered">done_all</mat-icon>
                                <mat-icon *ngIf="message.status === 'read'" class="status-icon read">done_all</mat-icon>
                                <mat-icon *ngIf="message.status === 'failed'" class="status-icon failed"
                                    [matTooltip]="failedTooltip(message)" matTooltipClass="ws-failed-tooltip">error</mat-icon>
                                <mat-icon *ngIf="message.status === 'pending_button_response'"
                                    class="status-icon pending"
                                    matTooltip="Waiting for button response">schedule</mat-icon>
                                <mat-icon *ngIf="message.status === 'rejected'" class="status-icon rejected"
                                    matTooltip="Rejected by user">cancel</mat-icon>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div *ngIf="messages.length === 0 && !loading && !broadcastMode" class="no-messages">
                    <mat-icon>chat_bubble_outline</mat-icon>
                    <p>No messages yet. Start a conversation!</p>
                </div>
            </div>

            <div class="no-conversation" *ngIf="!selectedConversation && conversations.length === 0 && !loading">
                <mat-icon>chat_bubble_outline</mat-icon>
                <p>No WhatsApp conversations found for this patient.</p>
                <p class="hint">Messages will appear here once you start a conversation.</p>
            </div>

            <div class="chat-input-area" *ngIf="patient" (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.drag-over]="isDragOver">
                <!-- Attached media preview -->
                <div *ngIf="attachedMedia.length > 0" class="attached-media-preview">
                    <div *ngFor="let media of attachedMedia; let i = index" class="media-preview-item">
                        <img *ngIf="media.mediaType === 'image'" [src]="media.preview" [alt]="media.filename"
                            class="media-preview-image">
                        <div *ngIf="media.mediaType !== 'image'" class="media-preview-icon">
                            <mat-icon *ngIf="media.mediaType === 'document'">insert_drive_file</mat-icon>
                            <mat-icon *ngIf="media.mediaType === 'video'">videocam</mat-icon>
                        </div>
                        <div class="media-preview-info">
                            <div class="media-preview-name">{{ media.filename }}</div>
                            <div class="media-preview-type">{{ media.mediaType }}</div>
                        </div>
                        <button mat-icon-button class="remove-media-btn" (click)="removeAttachedMedia(i)"
                            matTooltip="Remove">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="input-container">
                    <div class="attachment-menu-container">
                        <button mat-icon-button class="attachment-button" (click)="toggleAttachmentMenu()"
                            [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || recording || pendingRecording || (textMessageBalance !== null && hasInsufficientCredits)"
                            [class.active]="attachmentMenuOpen" matTooltip="Attach">
                            <mat-icon>attach_file</mat-icon>
                        </button>
                        <div class="attachment-menu" *ngIf="attachmentMenuOpen" (click)="$event.stopPropagation()">
                            <button class="attachment-menu-item" (click)="triggerFileInput()"
                                [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || recording || pendingRecording || (textMessageBalance !== null && hasInsufficientCredits)">
                                <mat-icon>attach_file</mat-icon>
                                <span>Attach files</span>
                            </button>
                            <button class="attachment-menu-item" (click)="openMediaSelector()"
                                [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || recording || pendingRecording || !patientMedia || patientMedia.length === 0 || (textMessageBalance !== null && hasInsufficientCredits)">
                                <mat-icon>folder</mat-icon>
                                <span>From patient file</span>
                            </button>
                            <button class="attachment-menu-item" (click)="openPrescriptionSelector()"
                                [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || recording || pendingRecording || patientPrescriptions.length === 0 || (textMessageBalance !== null && hasInsufficientCredits)">
                                <mat-icon>description</mat-icon>
                                <span>Prescription</span>
                            </button>
                            <!-- §30. The practice's documents, beside its siblings. NOT disabled on
                                 an empty list the way they are: this one loads its rows when the
                                 dialog opens, so there is nothing to count here, and the dialog
                                 says so itself when the practice has none. -->
                            <button class="attachment-menu-item" (click)="openPracticeDocumentSelector()"
                                [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || recording || pendingRecording || (textMessageBalance !== null && hasInsufficientCredits)">
                                <mat-icon>fact_check</mat-icon>
                                <span>Practice document</span>
                            </button>
                            <button class="attachment-menu-item" (click)="openBillingDocumentSelector()"
                                [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || recording || pendingRecording || billingDocuments.length === 0 || (textMessageBalance !== null && hasInsufficientCredits)">
                                <mat-icon>receipt</mat-icon>
                                <span>Invoice/Receipt</span>
                            </button>
                        </div>
                    </div>
                    <input type="file" id="whatsapp-file-input" #fileInput (change)="onFileSelected($event)"
                        accept="image/*,video/*,application/pdf,.doc,.docx,.xls,.xlsx" multiple style="display: none;">
                    <mat-form-field appearance="outline" class="message-input">
                        <textarea matInput [(ngModel)]="newMessage" (keydown)="onKeyDown($event)"
                            (input)="autoResizeTextarea()" (focus)="onInputFocus()" (blur)="onInputBlur()"
                            [placeholder]="messagePlaceholder" rows="1"
                            [disabled]="!selectedConversation && !patient.mobileNumber || recording || !!pendingRecording || (textMessageBalance !== null && hasInsufficientCredits)"
                            #messageInput></textarea>
                    </mat-form-field>
                    <!-- Combined send/recording button with send menu -->
                    <div class="send-menu-container" *ngIf="hasTextOrMedia()">
                        <button mat-icon-button [color]="hasTextOrMedia() ? 'primary' : undefined"
                            [class.voice-button]="!hasTextOrMedia()" [class.send-button]="hasTextOrMedia()"
                            [class.active]="sendMenuOpen" (click)="onSendOrRecordClick($event)"
                            [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || (hasTextOrMedia() && recording) || (textMessageBalance !== null && hasInsufficientCredits)"
                            [matTooltip]="hasInsufficientCredits ? 'Insufficient credits to send messages' : (hasTextOrMedia() ? 'Send message' : (isTouchDevice ? 'Hold to record voice note' : (recording ? 'Click to stop and send' : 'Click to start recording')))">
                            <!-- Send button icon -->
                            <mat-icon *ngIf="hasTextOrMedia() && !sending && !recording">send</mat-icon>
                            <mat-spinner *ngIf="hasTextOrMedia() && sending" diameter="20"></mat-spinner>
                        </button>
                        <div class="send-menu" *ngIf="sendMenuOpen" (click)="$event.stopPropagation()">
                            <button class="send-menu-item" (click)="sendAsText()" [disabled]="sending || recording">
                                <mat-icon>text_fields</mat-icon>
                                <span>Send as text</span>
                            </button>
                            <button class="send-menu-item" (click)="sendAsPdf()" [disabled]="sending || recording">
                                <mat-icon>picture_as_pdf</mat-icon>
                                <span>Convert to PDF</span>
                            </button>
                            <button class="send-menu-item" (click)="sendAsPdfWithSignature()"
                                [disabled]="sending || recording || !signatureContext.canSign"
                                *ngIf="signatureContext.canSign">
                                <mat-icon>draw</mat-icon>
                                <span>Convert to PDF with signature</span>
                            </button>
                        </div>
                    </div>
                    <!-- Recording button (when no text/media) -->
                    <!-- Supports both touch (press and hold) and click (click to start/stop) on hybrid devices -->
                    <button mat-icon-button *ngIf="!hasTextOrMedia() && !pendingRecording"
                        [class.voice-button]="!hasTextOrMedia()" (click)="onSendOrRecordClick($event)"
                        (touchstart)="onSendOrRecordTouchStart($event)" (touchmove)="onSendOrRecordTouchMove($event)"
                        (touchend)="onSendOrRecordTouchEnd($event)" (touchcancel)="onSendOrRecordTouchCancel($event)"
                        [disabled]="sending || (!selectedConversation && !patient.mobileNumber) || (textMessageBalance !== null && hasInsufficientCredits)"
                        [matTooltip]="hasInsufficientCredits ? 'Insufficient credits to send messages' : (isTouchDevice ? 'Hold to record or click to start' : (recording ? 'Click to stop recording' : 'Click to start recording'))">
                        <!-- Recording button icon -->
                        <mat-icon *ngIf="!recording">mic</mat-icon>
                        <mat-icon *ngIf="recording" class="recording-pulse">mic</mat-icon>
                    </button>

                </div>
                <!-- Recording indicator with waveform (matches WhatsApp design) -->
                <!-- Show when actively recording OR when there's a pending recording -->
                <div *ngIf="recording || pendingRecording" class="recording-indicator" [class.paused]="recordingPaused"
                    [class.pending]="pendingRecording && !recording">
                    <!-- Delete icon (show when actively recording and using click interaction) -->
                    <button *ngIf="recording && !isUsingTouchInteraction" mat-icon-button (click)="cancelRecording()"
                        class="delete-button-inline" matTooltip="Delete recording">
                        <mat-icon>delete</mat-icon>
                    </button>

                    <!-- Recording icon and timer -->
                    <div class="recording-time-container">
                        <mat-icon *ngIf="recording && !recordingPaused"
                            class="recording-icon">fiber_manual_record</mat-icon>
                        <!-- <mat-icon *ngIf="recording && recordingPaused" class="play-icon">play_arrow</mat-icon>
                        <mat-icon *ngIf="pendingRecording && !recording" class="mic-icon-pending">mic</mat-icon> -->
                        <span class="recording-time">{{ formatRecordingTime(recordingTime) }}</span>
                    </div>

                    <!-- Audio waveform visualization (only show when actively recording) -->
                    <div *ngIf="recording" class="audio-waveform" [class.paused]="recordingPaused">
                        <div class="waveform-bar" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]"
                            [class.paused]="recordingPaused" [style.animation-delay.ms]="i * 50"></div>
                    </div>

                    <!-- Touch interaction hints (show when using touch and actively recording) -->
                    <span *ngIf="recording && isUsingTouchInteraction" class="recording-hint">
                        <span *ngIf="showCancelHint" class="hint-cancel">← Slide left to cancel</span>
                        <span *ngIf="showLockHint" class="hint-lock">↑ Slide up to lock</span>
                        <span *ngIf="!showCancelHint && !showLockHint">Release to finish</span>
                    </span>

                    <!-- Controls at the end -->
                    <div class="recording-controls-end">
                        <!-- Active recording controls (pause/resume and send) -->
                        <ng-container *ngIf="recording && !isUsingTouchInteraction">
                            <!-- Pause icon (only when recording, not paused) -->
                            <button *ngIf="!recordingPaused" mat-icon-button (click)="pauseRecording()"
                                class="pause-button-inline m-r-5" matTooltip="Pause recording">
                                <mat-icon>pause</mat-icon>
                            </button>

                            <!-- Play/Resume button and mic icon (when paused) -->
                            <button *ngIf="recordingPaused" mat-icon-button (click)="pauseRecording()"
                                class="resume-button-inline m-r-5" matTooltip="Resume recording">
                                <mat-icon>mic</mat-icon>
                            </button>
                            <!-- <mat-icon *ngIf="recordingPaused" class="mic-icon-paused">mic</mat-icon> -->

                            <!-- Send button (stop recording and send directly) -->
                            <button mat-icon-button (click)="stopAndSendRecording()" class="send-button-inline"
                                [disabled]="textMessageBalance !== null && hasInsufficientCredits"
                                matTooltip="Send voice note">
                                <mat-icon>send</mat-icon>
                            </button>
                        </ng-container>

                        <!-- Pending recording controls (send and delete) -->
                        <ng-container *ngIf="pendingRecording && !recording">
                            <button mat-icon-button (click)="deleteRecording(); $event.stopPropagation()"
                                class="delete-button-inline m-r-5" matTooltip="Delete recording">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-icon-button (click)="sendPendingRecording(); $event.stopPropagation()"
                                class="send-button-inline"
                                [disabled]="sending || (textMessageBalance !== null && hasInsufficientCredits)"
                                matTooltip="Send voice note">
                                <mat-icon>send</mat-icon>
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="isDragOver" class="drag-over-indicator">
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Drop files here to attach</span>
                </div>
            </div>
        </div>
    </div>

    <div class="no-patient" *ngIf="!patient">
        <mat-icon>person_off</mat-icon>
        <p>No patient selected</p>
    </div>
</div>